import React from "react";
import PropTypes from "prop-types";
import Svg from "react-svg-inline";
import selectIcon from "./selectIcon.svg";
import styles from "./index.module.css";

const SelectControl = ({ label, values, selectedId, onChange }) => (
  <div className={styles.root}>
    <label className={styles.label}>
      Dataset
      <select className={styles.element} onChange={onChange} value={selectedId}>
        {values.map(value => (
          <option key={value.id} value={value.id}>
            {value.name}
          </option>
        ))}
      </select>
      <Svg className={styles.icon} svg={selectIcon} />
    </label>
  </div>
);

SelectControl.propTypes = {
  label: PropTypes.string,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })
  ),
  selectedId: PropTypes.number,
  onChange: PropTypes.func
};

export default SelectControl;



// WEBPACK FOOTER //
// ./src/components/SelectControl/index.js